import { render, staticRenderFns } from "./PinpadTransactions.vue?vue&type=template&id=2589e81c&"
import script from "./PinpadTransactions.vue?vue&type=script&lang=js&"
export * from "./PinpadTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports